import { useState } from "react"

import { Translate } from "../../Components/Translator"

const EmbeddedHubspotSettings = (props) => {

    const [mRepainter, SetRepainter] = useState(0)

    return (
        <>           
            <tr className="usersettings">
                <td width="200" className="foregroundlightasbackground" valign="center">{Translate("Automatic actions")}</td>
                <td width="*" valign="center">
                    {Translate("What actions should be automatically performed?")}<br/>
                    <br/>
                    <input type="checkbox" style={{ paddingLeft: "2px" }} onChange={(evt) => { localStorage.setItem("hubspot_setting_collapse_on_save", evt.target.checked ? "1" : "0"); SetRepainter(mRepainter+1)}} checked={localStorage.getItem("hubspot_setting_collapse_on_save") === "1"}/> {Translate("Minimize app when saving notes after call ended")}<br/>
                </td>
            </tr>
        </>
    )
}

export default EmbeddedHubspotSettings